import { Component, inject, OnInit } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

const DEFAULT_ORIGINAL_URI = window.location.origin;

@Component({
  selector: 'wcg-login',
  styleUrls: ['./login.component.css'],
  templateUrl: './login.component.html',
  standalone: false,
})
export class LoginComponent implements OnInit {
  private readonly _oktaAuth: OktaAuth = inject(OKTA_AUTH);

  async ngOnInit(): Promise<void> {
    let originalUri = this._oktaAuth.getOriginalUri();

    if (!originalUri || originalUri === DEFAULT_ORIGINAL_URI) {
      originalUri = '/';
      this._oktaAuth.setOriginalUri(originalUri);
    }

    try {
      await this._oktaAuth.signInWithRedirect({ originalUri });
    } catch (err) {
      console.error('Error during Okta redirect', err);
    }
  }
}
